import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IUnmatchedOrderRepository } from '@/coreInfrastructureModule/interfaces/IUnmatchedOrderRepository';
import { BulkRegisterResult } from '../domains/entities/UnmatchedOrderItem';

/**
 * 未照合・差異一覧情報を更新するユースケース
 */
export class BulkRegisterUnmatchedOrderBusinessUseCase {
  private repository: IUnmatchedOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IUnmatchedOrderRepository) {
    this.repository = repository;
  }

  /**
   * 未照合の発注取引を登録する
   * @param unmatchedOrderIds - 登録する未照合IDリスト
   * @returns 更新されたID一覧
   */
  public async execute(unmatchedOrderIds: string[]): Promise<INetworkResult<BulkRegisterResult, IError>> {
    const networkResult = await this.repository.bulkRegister({ unmatchedOrderIds });
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: networkResult.status.data.result,
          },
        };
      case 'error':
      default:
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
